import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MapThemeEditorComponent } from '../../map-theme-editor/map-theme-editor.component';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';

export class RouteStatusConfig {
  defaultLegendSettings: LayerTypeFilter;
  legendSettings: LayerTypeFilter;
}

@Component({
  selector: 'app-route-status-config',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MapThemeEditorComponent,
  ],
  templateUrl: './route-status-config.component.html',
  styleUrl: './route-status-config.component.scss',
})
export class RouteStatusConfigComponent {

  static readonly LEGEND_NOT_DONE = 'Not Done';
  static readonly LEGEND_LEVEL1 = 'Done < 2h';
  static readonly LEGEND_LEVEL2 = 'Done 2-5h';
  static readonly LEGEND_LEVEL3 = 'Done 5-12h';

  constructor(
    public dialogRef: MatDialogRef<RouteStatusConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RouteStatusConfig,
  ) {}

  reset() {
    const notDone = this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE);
    const defaultNotDone = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE);
    if (notDone && defaultNotDone) {
      notDone.color = defaultNotDone.color;
      notDone.dashArray = defaultNotDone.dashArray;
    }

    const level1 = this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1);
    const defaultLevel1 = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1);
    if (level1 && defaultLevel1) {
      level1.color = defaultLevel1.color;
      level1.dashArray = defaultLevel1.dashArray;
    }

    const level2 = this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2);
    const defaultLevel2 = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2);
    if (level2 && defaultLevel2) {
      level2.color = defaultLevel2.color;
      level2.dashArray = defaultLevel2.dashArray;
    }

    const level3 = this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3);
    const defaultLevel3 = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3);
    if (level3 && defaultLevel3) {
      level3.color = defaultLevel3.color;
      level3.dashArray = defaultLevel3.dashArray;
    }
  }

  isDefault() {
    return this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE)?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE)?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE)?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE)?.dashArray &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1)?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1)?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1)?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1)?.dashArray &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2)?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2)?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2)?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2)?.dashArray &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3)?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3)?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3)?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3)?.dashArray;
  }
}
